import { NgModule } from '@angular/core';
import { WsTypeaheadDirective } from './typeahead.directive';

@NgModule({
    imports: [
        WsTypeaheadDirective
    ],
    exports: [WsTypeaheadDirective]
})
export class WsTypeaheadModule {
}
